export default "__VITE_ASSET__clv8lG5d__"